export default "__VITE_PUBLIC_ASSET__836b9e39__"